import React from 'react';
import PropTypes from 'prop-types';
import AsyncElasticsearchMultiSelect from './AsyncElasticsearchMultiSelect';
import { updateAirlineMultiselect } from '../../../modules/DataExports/redux/actions';

const propTypes = {
  dispatch: PropTypes.func,
  value: PropTypes.array,
  onInputOpen: PropTypes.func,
  onInputClose: PropTypes.func,
};

const AirlineMultiSelect = ({
  dispatch, value, onInputOpen, onInputClose,
}) => (
  <div>
    <AsyncElasticsearchMultiSelect
      dispatch={dispatch}
      type='airline'
      name='airline-multiselect'
      placeholder='Example: AA or American Airlines'
      action={updateAirlineMultiselect}
      value={value}
      isOptionUnique
      onInputOpen={onInputOpen}
      onInputClose={onInputClose}
    />
  </div>
);

AirlineMultiSelect.propTypes = propTypes;

export default AirlineMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lib/AirlineMultiSelect.js